const OrdersIcon = ({
  width = 24,
  height = 24,
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={color}
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M473.31 123.608 262 1.608a12 12 0 0 0-12 0l-211.31 122a12 12 0 0 0-6 10.392v244a12 12 0 0 0 6 10.392l211.31 122a12 12 0 0 0 12 0l211.31-122a12 12 0 0 0 6-10.392V134a12 12 0 0 0-6-10.392zM256 242.144 174.345 195l187.31-108.143L443.31 134zm0-216.287L337.655 73l-187.31 108.144L68.691 134zM56.69 154.784l81.7 47.171v112.482a12 12 0 0 0 24 0v-98.625L244 262.928v216.287L56.69 371.071zM268 479.215V262.928l187.31-108.143v216.286z" />
  </svg>
);

export default OrdersIcon;
